import type { SelectProps } from '@/components/Select/Select.d';

const Select = (props: SelectProps) => {
  return (
    <>
      <label htmlFor={props.id}>{props.labelText}</label>
      <select
        className="form--select"
        defaultValue={props.defaultValue}
        id={props.id}
        key="select"
        onChange={props.onChange}
        onFocus={props.onFocus}
        required={props.required}
        value={props.value}
      >
        {Object.entries(props.options).map(([ key, value ]) => (
          <option
            disabled={key === ''}
            hidden={key === ''}
            key={key}
            value={key ? key : ''}
          >
            {key === '' && props.required ? `${value}*` : value}
          </option>
        ))}
      </select>
    </>
  );
};

export { Select };
